import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const VerifyLink = (props) => {
  const [successLoad, setSuccessLoad] = useState("");

  let { verify_mail } = useParams();
  let { verify_code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    props.actSidebar(false);
    props.checkLoggedIn(false);

    axios
      .post(window.ajaxLink + "user/verify-link", { email: verify_mail, otpcode: verify_code })
      .then((res) => {
        if (res.data.responseData) {
          navigate("/reset-password/" + verify_mail);
        }
      })
      .catch((error) => {
        console.error(error);
        if (error.response.data.responseCode === 417) {
          setSuccessLoad(error.response.data.errorData);
        }
      });
      // eslint-disable-next-line
  }, []);

  return (
    <div>
      {successLoad && (
        <div className="dlt_wrapper">
          <div className="dbl_place_on_page">
            <div className="dlt_surround">
              <div className="dlt_title">Verify Status</div>
              <div className="dlt_description">{successLoad}</div>
              <div className="dlt_exit_btm">
                <div className="dlt_exit_btn dlt_eb_scnd dlt_lone_btn" onClick={() => navigate("/")}>
                  OK
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VerifyLink;
